<mat-card>
  <h2 translate>request.title</h2>
  <form (ngSubmit)="calculateFinance()" [formGroup]="requestDataMgForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="50" fxFlex.gt-sm="40">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="commercialProduct"
          [id]="'commercialProductMgData'"
          [dataInput]="commercialProductList"
          [placeholder]="'request.commercialProduct'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.commercialProduct?.errors"
          (selectionChange)="onCommercialProductSelected($event)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="lineProduct"
          [id]="'lineProductMgData'"
          [dataInput]="lineProductList"
          [placeholder]="'request.lineProduct'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.lineProduct?.errors"
          (selectionChange)="onLineProductSelected(true)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="product"
          [id]="'productMgData'"
          [dataInput]="productList"
          [placeholder]="'request.product'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.product?.errors"
        ></scf-custom-select-search>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.requestedAmount</mat-label>
          <input
            id="requestedAmountMgData"
            matInput
            maxlength="13"
            formControlName="requestedAmount"
            (keypress)="numberOnly($event)"
            (blur)="getFormattedAmount()"
            [(value)]="formattedAmount"
            autocomplete="off"
          />
          <mat-error *ngIf="requestDataMgForm.controls.requestedAmount.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.term</mat-label>
          <input
            id="termMgData"
            matInput
            maxlength="3"
            (keypress)="numberOnly($event)"
            pattern="^(0|[1-9][0-9]{0,9})$"
            formControlName="term"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="expirationDay"
          [id]="'expirationDayMgData'"
          [dataInput]="expirationDaysList"
          [placeholder]="'request.expireDate'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.expirationDay?.errors"
        ></scf-custom-select-search>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="40">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="formPayment"
          [id]="'formPaymentMgData'"
          [dataInput]="formPaymentList"
          [placeholder]="'requestDataMg.paymentMode'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.formPayment?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="tariffs"
          [id]="'tariffsMgData'"
          [dataInput]="tariffsList"
          [placeholder]="'request.tariffs'"
          [isRequired]="true"
          [showErrors]="requestDataMgForm?.controls?.tariffs?.errors"
          [selectorIdProperty]="'codigo'"
          [selectorValueProperty]="'descripcion'"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="mode !== 'view'">
        <div fxFlex="100" class="request__button-calculate">
          <button
            id="calculateuttonMgData"
            color="primary"
            type="submit"
            mat-flat-button
            [disabled]="!buttonEnabled || isLoading"
          >
            <mat-label translate>request.buttonCalculate</mat-label>
          </button>
        </div>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="mode === 'view'">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestFinance.percentageDiscount</mat-label>
          <input id="discountPercentageMgData" matInput formControlName="discountPercentage" autocomplete="off" />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="mode === 'view'">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestFinance.percentageWelcome</mat-label>
          <input id="discountWelcomeMgData" matInput formControlName="discountWelcome" autocomplete="off" />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="mode === 'view'">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestFinance.netPursacheAmount</mat-label>
          <input id="netPurchaseAmountMgData" matInput formControlName="netPurchaseAmount" autocomplete="off" />
        </mat-form-field>
      </div>
      <!-- end row view mode -->
    </div>
  </form>
</mat-card>
